import { ChangeEvent, useState, useEffect, FC } from "react"
import s from "./UpdateStoks.module.css"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { Modal } from "../../features/Modal/Modal"
import { selectOrdersStore } from "../../app/reducers/ordersReducer"
import {
  deleteMetroRecode,
  metroUpdateStoks,
  selectUpdateStoksMetroStore,
  updateMetroState,
  uploadRecodeMetro,
} from "../../app/reducers/updateStoksMetro"
import { TipMetro } from "./components"
import { StatusInfo } from "../UpdateStoksIcon/StatusInfo/StatusInfo"
import { StorageSelectControl } from "../StorageSelect/StorageSelectControl"
import { MARKETPLACE } from "@acc/shared"
import { Checkbox, Button } from "@radix-ui/themes"

export const UpdateStoksMetro: FC = () => {
  const dispatch = useAppDispatch()
  const [selectedStorageId, setSelectedStorages] = useState("")
  const [isOpenModalUpdatePrices, setOpenModalUpdatePrices] = useState(false)
  const [updatePrices, setUpdatePrices] = useState(false)
  const [updateStocks, setUpdateStocks] = useState(false)

  useEffect(() => {
    dispatch(updateMetroState())
  }, [dispatch])

  const updateStoksStore = useAppSelector(selectUpdateStoksMetroStore)
  const ordersStore = useAppSelector(selectOrdersStore)
  const { lastStoksUpdated, lastPricesUpdated, status, isCurrentDataUploaded } =
    updateStoksStore.wildberries || {}
  const { storages } = ordersStore

  const handleUpdate = () => {
    if (
      (updatePrices || updateStocks) &&
      isCurrentDataUploaded &&
      selectedStorageId
    ) {
      setOpenModalUpdatePrices(true)
    }
  }

  return (
    <div className={s.updateStoksWrapper}>
      <h5>Обновление остатков и цен Метро</h5>
      {lastPricesUpdated && (
        <h6>
          Последнее обновление цен:{" "}
          {new Date(lastPricesUpdated).toLocaleString()}
        </h6>
      )}
      {lastStoksUpdated && (
        <h6>
          Последнее обновление остатков:{" "}
          {new Date(lastStoksUpdated).toLocaleString()}
        </h6>
      )}
      {status && (
        <h6>
          Статус: <StatusInfo status={status} />
        </h6>
      )}

      <div className={s.uploadFileWrap}>
        {isCurrentDataUploaded ? (
          <div>
            <Button
              onClick={() => {
                dispatch(deleteMetroRecode())
              }}
            >
              удалить файл перекодировки
            </Button>
          </div>
        ) : (
          <div>
            <Button asChild>
              <label htmlFor={s.ktrnFileInp}>
                Загрузить файл перекодировки
                <input
                  style={{ display: "none" }}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    const file = e.target.files?.[0]
                    if (file) {
                      dispatch(uploadRecodeMetro(file))
                    }
                  }}
                  type="file"
                  accept=".xlsx"
                  id={s.ktrnFileInp}
                />
              </label>
            </Button>
          </div>
        )}
        <TipMetro />
      </div>

      <StorageSelectControl
        label="Склад для обновления"
        value={selectedStorageId}
        onChange={(value) => {
          setSelectedStorages(value)
        }}
        controlKey="storages-select"
        marketplace={MARKETPLACE.WB}
      />
      <div className={s.checkboxContainer}>
        <label>
          <Checkbox
            checked={updatePrices}
            onCheckedChange={(value) => setUpdatePrices(value === true)}
          />
          Обновить цены
        </label>
        <label>
          <Checkbox
            checked={updateStocks}
            onCheckedChange={(value) => setUpdateStocks(value === true)}
          />
          Обновить остатки
        </label>
      </div>
      <Button
        className={s.updateButton}
        disabled={
          !isCurrentDataUploaded ||
          !selectedStorageId ||
          (!updatePrices && !updateStocks)
        }
        onClick={handleUpdate}
      >
        Обновить Метро
      </Button>

      <Modal
        isOpen={isOpenModalUpdatePrices}
        header="Подтвердите действие. Обновление на Метро"
        content={`Обновить ${updatePrices ? "цены" : ""} ${
          updatePrices && updateStocks ? "и" : ""
        } ${updateStocks ? "остатки" : ""} для склада ${
          storages.find((el) => el.id === +selectedStorageId)?.name
        }`}
        onClose={() => setOpenModalUpdatePrices(false)}
        onOk={() => {
          selectedStorageId &&
            dispatch(
              metroUpdateStoks({
                selectedStorageId,
                updatePrices,
                updateStocks,
              }),
            )
          setOpenModalUpdatePrices(false)
        }}
      />
    </div>
  )
}
